import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {UnreachableError} from '../../../../../libs/shared/core/src/helpers/types/customErrors';
import {HandoffErrorBannerTypesEnum} from '../../../../../libs/shared/core/src/models/handoff/handoffErrors';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {HandoffErrorBannerState} from '../../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface HandoffErrorBannerProps {
  state: HandoffErrorBannerState;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const HandoffErrorBanner: FC<HandoffErrorBannerProps> = (props) => {
  const theme = useUserTheme();
  const {state, onDismissClick} = props;

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerContent>
        <BannerContentTitle>
          <Trans id="handoff-error-banner-title">Failed to resume user activity.</Trans>
        </BannerContentTitle>
        {getBannerContent(state)}
      </BannerContent>
    </Banner>
  );
};

const getBannerContent = (state: HandoffErrorBannerState) => {
  const errorType = state.handoffErrorType;
  switch (errorType) {
    case HandoffErrorBannerTypesEnum.HANDOFF_APPLICATION_ERROR:
      return state.handoffError;
    case HandoffErrorBannerTypesEnum.HANDOFF_INVALID_PAYLOAD:
      return <Trans id="handoff-error-banner-invalid-payload">Invalid context.</Trans>;
    case HandoffErrorBannerTypesEnum.HANDOFF_INVALID_USER_ID:
      return (
        <Trans id="handoff-error-banner-invalid-user-id">
          You need to sign in with the same account on both devices.
        </Trans>
      );
    default:
      throw new UnreachableError(errorType);
  }
};
